<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <web-components-user-notes target="tickets" [dismissibleNotes]="true" />
      </div>
    </div>
    <tickets-faq-hint />
    <tickets-ticket-list [openTicketId]="ticketToNavigate" />
  </div>
</div>
